/* ==========================================================================
   BABYSLOFJE-ONLINE · gedrag van de nieuwe stijl
   Header, menu, aankondigingsbalk, hero-slideshow, carrousels, snel toevoegen
   met melding, nieuwsbrief en beweging (GSAP + ScrollTrigger).
   Zonder JavaScript of met "minder beweging" staat alles direct goed.
   ========================================================================== */
(function () {
  'use strict';
  var root = document.documentElement;
  var body = document.body;
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var cfg = window.bsTheme || {};
  var FREE = cfg.freeShipping || 4000;
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  function money(cents) {
    if (window.theme && theme.Currency && theme.Currency.formatMoney && cfg.moneyFormat) {
      return theme.Currency.formatMoney(cents, cfg.moneyFormat).replace(/<[^>]*>/g, '');
    }
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  /* ---------- Winkelwagen: teller, melding, snel toevoegen ---------- */
  var toast = $('#BsToast'), toastTimer;
  function setCount(n) {
    $$('[data-bs-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n < 1;
      el.classList.add('bump');
      setTimeout(function () { el.classList.remove('bump'); }, 300);
    });
    $$('[data-bs-cart-link]').forEach(function (a) {
      a.setAttribute('aria-label', 'Winkelwagen, ' + n + (n === 1 ? ' product' : ' producten'));
    });
  }
  function showToast(item, cart) {
    if (!toast) return;
    toast.classList.remove('is-error');
    var img = $('[data-bs-toast-img]', toast);
    var src = item && (item.featured_image && item.featured_image.url || item.image);
    if (src) { img.style.display = ''; img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=160'; }
    else img.style.display = 'none';
    $('[data-bs-toast-title]', toast).textContent = (item && (item.product_title || item.title)) || 'Toegevoegd';
    var total = cart ? cart.total_price : 0;
    var left = FREE - total;
    $('[data-bs-toast-sub]', toast).textContent = left > 0
      ? 'In je winkelwagen. Nog ' + money(left) + ' tot gratis verzending.'
      : 'In je winkelwagen. Je verzending is gratis.';
    var bar = $('[data-bs-toast-bar]', toast);
    bar.style.transform = 'scaleX(0)';
    toast.classList.add('on');
    requestAnimationFrame(function () { requestAnimationFrame(function () { bar.style.transform = 'scaleX(' + Math.min(1, total / FREE) + ')'; }); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove('on'); }, 3800);
  }
  function showError(msg) {
    if (!toast) return;
    toast.classList.add('is-error');
    $('[data-bs-toast-title]', toast).textContent = 'Dat lukte niet';
    $('[data-bs-toast-sub]', toast).textContent = msg || 'Probeer het nog een keer.';
    toast.classList.add('on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove('on'); }, 4200);
  }
  function refreshCart(item) {
    return fetch((cfg.cartUrl || '/cart') + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        setCount(cart.item_count);
        if (item) showToast(item, cart);
        document.dispatchEvent(new CustomEvent('bs:cart', { detail: { cart: cart } }));
        return cart;
      });
  }
  function addToCart(body, isJson) {
    return fetch((cfg.cartAddUrl || '/cart/add') + '.js', {
      method: 'POST', credentials: 'same-origin', body: body,
      headers: isJson ? { 'Content-Type': 'application/json', Accept: 'application/json' } : { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok || data.status) throw data;
        return data.items ? data.items[0] : data;
      });
    });
  }
  function doneButton(btn) {
    btn.classList.remove('is-loading');
    btn.classList.add('done');
    btn.innerHTML = '<svg aria-hidden="true"><use href="#i-check"/></svg>';
    setTimeout(function () { btn.classList.remove('done'); btn.innerHTML = '<svg aria-hidden="true"><use href="#i-plus"/></svg>'; }, 1600);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bs-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');
    addToCart(JSON.stringify({ items: [{ id: +btn.getAttribute('data-bs-add'), quantity: 1 }] }), true)
      .then(function (item) { doneButton(btn); return refreshCart(item); })
      .catch(function (err) { btn.classList.remove('is-loading'); showError(err && (err.description || err.message)); });
  });

  /* Productkeuze in het snel-toevoegen-venster (Expanse) via AJAX, zodat je op de pagina blijft */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[action*="/cart/add"]') || !form.closest('#QuickAddModal, #QuickAddHolder')) return;
    e.preventDefault();
    var submit = form.querySelector('[type="submit"]');
    if (submit) submit.classList.add('btn--loading');
    addToCart(new FormData(form), false)
      .then(function (item) {
        if (submit) submit.classList.remove('btn--loading');
        var close = $('#QuickAddModal .js-modal-close');
        if (close) close.click();
        return refreshCart(item);
      })
      .catch(function (err) {
        if (submit) submit.classList.remove('btn--loading');
        showError(err && (err.description || err.message));
      });
  }, true);

  /* Voortgang naar gratis verzending op de winkelwagenpagina bijwerken */
  function updateShip(cart) {
    $$('[data-bs-ship]').forEach(function (el) {
      var left = FREE - cart.total_price;
      el.classList.toggle('is-free', left <= 0);
      el.firstChild && (el.innerHTML = (left > 0 ? 'Nog <b>' + money(left) + '</b> tot gratis verzending.' : 'Je verzending is gratis.') +
        '<div class="bs-tbar" aria-hidden="true"><i style="transform:scaleX(' + Math.min(1, cart.total_price / FREE) + ')"></i></div>');
    });
  }
  document.addEventListener('cart:updated', function (evt) {
    var cart = evt.detail && evt.detail.cart;
    if (cart) { setCount(cart.item_count); updateShip(cart); }
  });
  document.addEventListener('bs:cart', function (evt) { updateShip(evt.detail.cart); });

  /* Expanse meldt toevoegingen ook zelf (bijv. vanuit aanbevelingen) */
  document.addEventListener('ajaxProduct:added', function (evt) {
    var p = evt.detail && evt.detail.product;
    refreshCart(p && p.items ? p.items[0] : p);
  });

  /* Snel toevoegen met varianten: het keuzevenster van Expanse koppelen aan onze secties */
  function bindQuickAdd() {
    if (!(window.theme && theme.QuickAdd)) return;
    $$('[data-bs-quickadd-scope]').forEach(function (el) {
      if (el.__bsQa || !el.querySelector('.js-quick-add-form')) return;
      el.__bsQa = true;
      new theme.QuickAdd(el);
    });
  }

  /* ---------- Aankondigingsbalk wisselt onder 1320px ---------- */
  var annBox = $('[data-bs-ann]');
  if (annBox) {
    var ann = $$(':scope > span, :scope > a', annBox), ai = 0;
    if (ann.length > 1 && !reduce) {
      setInterval(function () {
        if (innerWidth >= 1320 || document.hidden) return;
        ann[ai].classList.remove('on'); ai = (ai + 1) % ann.length; ann[ai].classList.add('on');
      }, 3500);
    }
  }

  /* ---------- Header: maat meten, verbergen bij omlaag scrollen ---------- */
  var hw = $('[data-bs-header]'), hdr = $('#SiteHeader');
  var menu = $('[data-bs-menu]'), burger = $('[data-bs-burger]');
  var hero = $('[data-bs-hero]');
  function measure() {
    if (hdr) root.style.setProperty('--hdr-h', hdr.offsetHeight + 'px');
    if (hero) {
      /* zelfde marge links, rechts en onder; links valt gelijk met de rest van de pagina (max 88px) */
      var ref = $('.bs-usp ul') || $('.bs-main .bs-wrap');
      if (ref) {
        var hr = hero.getBoundingClientRect(), ur = ref.getBoundingClientRect();
        var pad = parseFloat(getComputedStyle(ref).paddingLeft) || 0;
        var left = ref.matches('ul') ? ur.left : ur.left + pad;
        root.style.setProperty('--hp-js', Math.max(16, Math.min(88, Math.round(left - hr.left))) + 'px');
      }
    }
  }
  measure();
  addEventListener('resize', measure);
  if (window.ResizeObserver && hdr) new ResizeObserver(measure).observe(hdr);
  /* Menu past nooit buiten de balk: als items niet op één rij passen, twee nette rijen */
  var nav = hdr && $('.bs-nav', hdr), navUl = nav && $(':scope > ul', nav), navRaf = 0;
  function fitNav() {
    navRaf = 0;
    if (!navUl || !nav.offsetWidth) return;
    nav.classList.remove('is-wrapped');
    var first = navUl.firstElementChild, last = navUl.lastElementChild;
    if (first && last && last.offsetTop > first.offsetTop + 2) nav.classList.add('is-wrapped');
  }
  if (navUl) {
    fitNav();
    addEventListener('resize', function () { if (!navRaf) navRaf = requestAnimationFrame(fitNav); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitNav);
    /* uitklapmenu's blijven binnen de header */
    $$(':scope > li', navUl).forEach(function (li) {
      var d = $('.bs-drop', li);
      if (!d) return;
      var place = function () {
        d.style.marginLeft = '';
        if (d.classList.contains('bs-drop--mega')) return;
        var hr = hdr.getBoundingClientRect(), r = d.getBoundingClientRect(), shift = 0;
        if (r.right > hr.right - 8) shift = hr.right - 8 - r.right;
        if (r.left + shift < hr.left + 8) shift = hr.left + 8 - r.left;
        if (shift) d.style.marginLeft = Math.round(shift) + 'px';
      };
      li.addEventListener('mouseenter', place);
      li.addEventListener('focusin', place);
    });
  }

  /* Zoeken op smallere schermen: het zoekveld klapt open in de header in plaats van naar een pagina te gaan */
  var sToggle = $('[data-bs-search-toggle]'), sDrop = $('[data-bs-search-drop]');
  function setSearch(open) {
    if (!sToggle || !sDrop || !hdr) return;
    hdr.classList.toggle('search-open', open);
    sToggle.setAttribute('aria-expanded', String(open));
    sToggle.setAttribute('aria-label', open ? 'Zoeken sluiten' : 'Zoeken');
    if (open) { var inp = $('input[type=search]', sDrop); if (inp) inp.focus(); }
  }
  if (sToggle && sDrop) {
    sToggle.addEventListener('click', function (e) {
      if (getComputedStyle(sToggle).display === 'none') return;
      e.preventDefault();
      if (typeof setMenu === 'function' && menu && menu.classList.contains('open')) setMenu(false);
      setSearch(!hdr.classList.contains('search-open'));
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && hdr.classList.contains('search-open')) { setSearch(false); sToggle.focus(); } });
    document.addEventListener('click', function (e) { if (hdr.classList.contains('search-open') && !hdr.contains(e.target)) setSearch(false); });
  }

  /* Topmerken: koppen en subkoppen (allemaal even hoog) als één lijst over de kolommen verdelen,
     zo gelijk mogelijk, in de volgorde uit Shopify. Een kop staat nooit los onderaan een kolom:
     dan schuift hij door naar de volgende kolom, bij zijn subkoppen. */
  $$('.bs-drop--mega.has-groups .bs-mega').forEach(function (mega) {
    var lines = $$('.grp > a', mega);
    if (lines.length < 2) return;
    var lastK = 0;
    var flow = function () {
      if (!mega.offsetWidth) return;
      var k = innerWidth >= 1100 ? 5 : 4;
      k = Math.max(1, Math.min(k, lines.length));
      if (k === lastK && mega.classList.contains('is-flow')) return;
      lastK = k;
      var n = lines.length, c, j, x;
      /* een kolom mag niet eindigen op een kop waarvan de subkoppen in de volgende kolom staan */
      var okCut = function (at) { return !(lines[at - 1].classList.contains('head') && lines[at].classList.contains('sub')); };
      /* van alle toegestane verdelingen de gelijkste kiezen (kleinste som van de kwadraten van de kolomlengtes) */
      var best = [], from = [];
      for (j = 0; j <= n; j++) { best[j] = [j ? j * j : Infinity]; from[j] = [0]; }
      for (c = 1; c < k; c++) for (j = 0; j <= n; j++) {
        best[j][c] = Infinity; from[j][c] = -1;
        for (x = 1; x < j; x++) {
          if (!okCut(x) || best[x][c - 1] === Infinity) continue;
          var v = best[x][c - 1] + (j - x) * (j - x);
          if (v < best[j][c]) { best[j][c] = v; from[j][c] = x; }
        }
      }
      var cuts = [], end = n;
      if (best[n][k - 1] === Infinity) { /* kan niet zonder losse kop: gewoon gelijk verdelen */
        for (c = 1; c < k; c++) cuts.push(Math.round(n * c / k));
      } else {
        for (c = k - 1; c > 0; c--) { end = from[end][c]; cuts.unshift(end); }
      }
      while (mega.firstChild) mega.removeChild(mega.firstChild);
      var bounds = [0].concat(cuts, [n]);
      for (c = 0; c < k; c++) {
        var col = document.createElement('div'), grp = document.createElement('div');
        col.className = 'col'; grp.className = 'grp';
        lines.slice(bounds[c], bounds[c + 1]).forEach(function (a) { grp.appendChild(a); });
        col.appendChild(grp); mega.appendChild(col);
      }
      mega.style.setProperty('--cols', k);
      mega.classList.add('is-flow');
    };
    flow();
    var ft; addEventListener('resize', function () { clearTimeout(ft); ft = setTimeout(flow, 150); });
  });

  /* De header scrolt met de pagina mee (zoals V1); niets te verbergen. */
  function setHidden() {}

  /* ---------- Mobiel menu ---------- */
  function setMenu(open) {
    if (!menu || !burger) return;
    if (open && hdr && hdr.classList.contains('search-open')) setSearch(false);
    if (open && hdr) menu.style.paddingTop = Math.round(hdr.getBoundingClientRect().bottom + 18) + 'px';
    menu.classList.toggle('open', open);
    menu.setAttribute('aria-hidden', String(!open));
    burger.setAttribute('aria-expanded', String(open));
    burger.setAttribute('aria-label', open ? 'Menu sluiten' : 'Menu openen');
    body.style.overflow = open ? 'hidden' : '';
    $$('.it > *', menu).forEach(function (el, i) { el.style.transitionDelay = open ? (80 + i * 40) + 'ms' : '0ms'; });
    if (open) setHidden(false);
    if ('inert' in menu) menu.inert = !open;
  }
  if (menu && burger) {
    if ('inert' in menu) menu.inert = true;
    burger.addEventListener('click', function () { setMenu(!menu.classList.contains('open')); });
    menu.addEventListener('click', function (e) { if (e.target.closest('a')) setMenu(false); });
    addEventListener('keydown', function (e) { if (e.key === 'Escape' && menu.classList.contains('open')) { setMenu(false); burger.focus(); } });
    matchMedia('(min-width: 900px)').addEventListener('change', function (m) { if (m.matches) setMenu(false); });
  }

  /* ---------- Carrousels ---------- */
  $$('[data-bs-rail]').forEach(function (rail) {
    var sec = rail.closest('section') || rail.parentNode;
    var prev = $('[data-rail-prev]', sec), next = $('[data-rail-next]', sec);
    if (!prev || !next) return;
    var gap = function () { return parseFloat(getComputedStyle(rail).columnGap) || 16; };
    var step = function () {
      var c = rail.firstElementChild; if (!c) return 300;
      var w = c.offsetWidth + gap();
      return w * Math.max(1, Math.floor(rail.clientWidth / w));
    };
    prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' }); });
    next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' }); });
    function state() {
      prev.disabled = rail.scrollLeft < 8;
      next.disabled = rail.scrollLeft + rail.clientWidth > rail.scrollWidth - 8;
    }
    rail.addEventListener('scroll', state, { passive: true });
    addEventListener('resize', state);
    state();
  });

  /* ---------- Hero-slideshow ---------- */
  var go = function () {};
  if (hero) {
    var slides = $$('.bs-slide', hero), media = $$('[data-media]', hero), dots = $$('.bs-dot', hero);
    var DUR = +hero.getAttribute('data-speed') || 6500, cur = 0, timer = null, paused = false;
    go = function (n) {
      if (!slides.length) return;
      hero.classList.add('is-live');
      cur = (n + slides.length) % slides.length;
      slides.forEach(function (s, i) {
        var on = i === cur;
        s.classList.toggle('on', on);
        s.setAttribute('aria-hidden', String(!on));
        $$('a', s).forEach(function (a) { a.tabIndex = on ? 0 : -1; });
      });
      media.forEach(function (m, i) {
        var on = i === cur;
        m.classList.toggle('on', on);
        var im = m.querySelector('img');
        if (on && im && im.loading === 'lazy') im.loading = 'eager';
      });
      dots.forEach(function (d, i) { d.classList.remove('on'); d.setAttribute('aria-selected', String(i === cur)); });
      if (dots[cur]) { void hero.offsetWidth; dots[cur].classList.add('on'); }
      /* volgende foto alvast laden */
      var nx = media[(cur + 1) % media.length], ni = nx && nx.querySelector('img');
      if (ni && ni.loading === 'lazy') ni.loading = 'eager';
      schedule();
    };
    var schedule = function () { clearTimeout(timer); if (!reduce && !paused && slides.length > 1) timer = setTimeout(function () { go(cur + 1); }, DUR); };
    dots.forEach(function (d) { d.addEventListener('click', function () { go(+d.getAttribute('data-go')); }); });
    var pause = function () { paused = true; hero.classList.add('paused'); clearTimeout(timer); };
    var resume = function () { paused = false; hero.classList.remove('paused'); schedule(); };
    /* Muis erop laat de slider gewoon doorlopen; alleen toetsenbordfocus pauzeert. */
    hero.addEventListener('focusin', function () { if (hero.querySelector(':focus-visible')) pause(); });
    hero.addEventListener('focusout', function (e) { if (paused && !hero.contains(e.relatedTarget)) resume(); });
    if (reduce) hero.classList.add('paused');
  }

  /* ---------- Productfoto's op telefoon: niet swipen, kiezen via de kleine foto's eronder ---------- */
  var mqSmall = matchMedia('(max-width: 768px)');
  function lockProductSwipe() {
    if (!window.Flickity || !Flickity.data) return;
    $$('.product__main-photos .product-slideshow.flickity-enabled').forEach(function (el) {
      var f = Flickity.data(el);
      if (!f || f.options.draggable === !mqSmall.matches) return;
      f.options.draggable = !mqSmall.matches;
      f.updateDraggable();
    });
  }
  if ($('.product__main-photos')) {
    lockProductSwipe();
    addEventListener('load', lockProductSwipe);
    if (mqSmall.addEventListener) mqSmall.addEventListener('change', lockProductSwipe);
    if (window.MutationObserver) $$('.product__main-photos .product-slideshow').forEach(function (el) {
      new MutationObserver(lockProductSwipe).observe(el, { attributes: true, attributeFilter: ['class'] });
    });
  }

  /* ---------- Artikelen: foto's in de tekst altijd in scherpe versie laden (de editor plaatst soms een kleine) ---------- */
  $$('.template-article .rte img').forEach(function (img) {
    var src = img.getAttribute('src') || '';
    if (!/cdn\.shopify\.com|\/cdn\/shop\//.test(src)) return;
    var sharp = src
      .replace(/_(pico|icon|thumb|small|compact|medium|large|grande|\d+x\d*|x\d+)(@\dx)?(?=\.[a-z]{3,4}(\?|$))/i, '')
      .replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
    sharp += (sharp.indexOf('?') > -1 ? '&' : '?') + 'width=1200';
    if (sharp !== src) { img.removeAttribute('srcset'); img.src = sharp; }
  });

  /* ---------- Nieuwsbrief: eerst zelf het adres controleren ---------- */
  var nl = $('#BsNewsletter');
  if (nl) {
    var msg = $('[data-bs-nl-msg]');
    if (msg && msg.textContent.trim() && location.hash !== '#BsNewsletter') { /* na versturen: melding staat al klaar */ }
    nl.addEventListener('submit', function (e) {
      var input = nl.querySelector('input[type="email"]'), v = input ? input.value.trim() : '';
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) {
        e.preventDefault();
        if (msg) msg.textContent = 'Vul een geldig e-mailadres in, bijvoorbeeld naam@voorbeeld.nl.';
        if (input) input.focus();
      }
    });
  }

  /* ===================== BEWEGING (GSAP) ===================== */
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function () {
    bindQuickAdd();
    var motion = !reduce && window.gsap && window.ScrollTrigger;
    var loader = $('#BsLoader');
    if (!motion) {
      root.classList.remove('js-motion');
      if (loader) loader.remove();
      go(0);
      return;
    }
    gsap.registerPlugin(ScrollTrigger);

    /* Intro (alleen homepage, één keer per sessie) */
    if (hero && root.classList.contains('js-motion')) {
      var seen = root.classList.contains('intro-seen');
      var firstImg = $('[data-media="0"] img', hero);
      var imgReady = new Promise(function (res) {
        if (!firstImg || firstImg.complete) return res();
        firstImg.addEventListener('load', res, { once: true });
        firstImg.addEventListener('error', res, { once: true });
        setTimeout(res, 1800);
      });
      var annEl = $('.bs-ann'), hwEl = $('.bs-hdr-wrap'), mediaEl = $('.bs-hero-media', hero), cardsEl = $('.bs-cards', hero), dotsEl = $('.bs-dots', hero);
      var targets = [cardsEl, dotsEl, hwEl, annEl].filter(Boolean);
      var inner = $$('.bs-slide.on .bs-core > *', hero);
      gsap.set(targets, { autoAlpha: 1 });
      /* header en balk alleen bij het eerste bezoek laten invliegen; daarna staan ze er meteen (geen knipperen) */
      if (seen) { annEl = null; hwEl = null; }
      if (annEl) gsap.set(annEl, { clipPath: 'inset(0 0 100% 0)' });
      if (hwEl) gsap.set(hwEl, { y: -30, autoAlpha: 0 });
      if (mediaEl) gsap.set(mediaEl, { scale: 1.1 });
      if (cardsEl) gsap.set(cardsEl, { y: 50, autoAlpha: 0 });
      gsap.set(inner, { y: 16, autoAlpha: 0 });
      if (dotsEl) gsap.set(dotsEl, { y: 20, autoAlpha: 0 });

      var heroIn = function (delay) {
        var tl = gsap.timeline({
          delay: delay, defaults: { ease: 'expo.out' },
          onComplete: function () {
            root.classList.remove('js-motion');
            gsap.set(targets.concat([mediaEl]).concat(inner).filter(Boolean), { clearProps: 'all' });
            go(0);
          }
        });
        if (mediaEl) tl.to(mediaEl, { scale: 1, duration: 2.2, ease: 'power3.out' }, 0);
        if (annEl) tl.to(annEl, { clipPath: 'inset(0 0 0% 0)', duration: .9 }, .1);
        if (hwEl) tl.to(hwEl, { y: 0, autoAlpha: 1, duration: 1 }, .2);
        if (cardsEl) tl.to(cardsEl, { y: 0, autoAlpha: 1, duration: 1.1 }, .4);
        tl.to(inner, { y: 0, autoAlpha: 1, duration: .8, stagger: .08, ease: 'power3.out' }, .55);
        if (dotsEl) tl.to(dotsEl, { y: 0, autoAlpha: 1, duration: .8, ease: 'power3.out' }, .8);
      };

      if (seen || !loader) { if (loader) loader.remove(); heroIn(.05); }
      else {
        var L = gsap.timeline();
        L.from($('img, b', loader), { y: 14, autoAlpha: 0, duration: .7, ease: 'power3.out' })
         .to($('.track i', loader), { scaleX: 1, duration: 1, ease: 'power2.inOut' }, .2);
        Promise.all([imgReady, new Promise(function (r) { L.eventCallback('onComplete', r); })]).then(function () {
          gsap.to(loader, { autoAlpha: 0, duration: .6, ease: 'power2.out', onComplete: function () { loader.remove(); } });
          heroIn(.2);
          try { sessionStorage.setItem('bso-intro', '1'); } catch (e) {}
        });
      }
    } else {
      root.classList.remove('js-motion');
      if (loader) loader.remove();
      go(0);
    }

    /* Zacht in beeld bij scrollen, één keer per blok. Wat al in beeld staat, komt direct. */
    var rv = $$('[data-rv]').filter(function (el) {
      var r = el.getBoundingClientRect();
      return r.top > innerHeight * .92;
    });
    if (rv.length) {
      gsap.set(rv, { y: 24, autoAlpha: 0, force3D: true });
      ScrollTrigger.batch(rv, {
        start: 'top 92%', once: true,
        onEnter: function (b) { gsap.to(b, { y: 0, autoAlpha: 1, duration: .7, ease: 'power2.out', stagger: .06, overwrite: true, clearProps: 'transform' }); }
      });
      /* vangnet: na het laden alles wat boven de vouw staat zichtbaar */
      addEventListener('load', function () { measure(); ScrollTrigger.refresh(); });
    }
  });

  /* ---------- Autoscroll voor schermopnames (homepage) ----------
     Toets S start/pauzeert; ?autoscroll in de URL start na de intro;
     ?autoscroll=80 stelt de snelheid in (px/s, standaard 120). */
  if (hero) {
    var params = new URLSearchParams(location.search);
    var speed = Math.max(10, parseFloat(params.get('autoscroll')) || 120);
    var running = false, raf = 0, last = 0, pos = 0;
    var max = function () { return root.scrollHeight - innerHeight; };
    var step = function (now) {
      if (!running) return;
      var dt = Math.min(.05, (now - last) / 1000); last = now;
      pos = Math.min(max(), pos + speed * dt);
      window.scrollTo(0, pos);
      if (pos >= max() - 1) { stop(); return; }
      raf = requestAnimationFrame(step);
    };
    var start = function () { if (running) return; running = true; pos = scrollY; last = performance.now(); root.style.scrollBehavior = 'auto'; raf = requestAnimationFrame(step); };
    var stop = function () { if (!running) return; running = false; cancelAnimationFrame(raf); root.style.scrollBehavior = ''; };
    addEventListener('keydown', function (e) {
      var t = e.target;
      if (t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.tagName === 'SELECT' || t.isContentEditable)) return;
      if ((e.key === 's' || e.key === 'S') && !e.metaKey && !e.ctrlKey && !e.altKey) { e.preventDefault(); running ? stop() : start(); }
      else if (running) stop();
    });
    ['wheel', 'touchstart', 'mousedown'].forEach(function (ev) { addEventListener(ev, stop, { passive: true }); });
    if (params.has('autoscroll')) setTimeout(start, root.classList.contains('intro-seen') || !root.classList.contains('js-motion') ? 2000 : 3400);
  }
})();
